import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

var API_BASE_URL = process.env.REACT_APP_API_BASE_URL;

export var fetchFaqs = createAsyncThunk(
  "faq/fetchFaqs",
  async function (language, thunkApi) {
    try {
      if (!API_BASE_URL) {
        throw new Error("REACT_APP_API_BASE_URL is not configured");
      }

      var response = await fetch(API_BASE_URL + "/faq", {
        method: "GET",
        signal: thunkApi.signal,
        headers: {
          Accept: "application/json",
          "Accept-Language": language || "en",
        },
      });

      var contentType = response.headers.get("content-type");

      if (!contentType || contentType.indexOf("application/json") === -1) {
        throw new Error("The FAQ endpoint returned an invalid response");
      }

      var responseData = await response.json();

      if (!response.ok) {
        return thunkApi.rejectWithValue(
          responseData.message || "Unable to retrieve FAQs"
        );
      }

      return {
        list: Array.isArray(responseData.data) ? responseData.data : [],
        pagination: responseData.pagination || null,
      };
    } catch (error) {
      return thunkApi.rejectWithValue(
        error.message || "Unable to connect to the server"
      );
    }
  }
);

var initialState = {
  list: [],
  pagination: null,
  loading: false,
  error: "",
};

var faqSlice = createSlice({
  name: "faq",
  initialState: initialState,
  reducers: {},
  extraReducers: function (builder) {
    builder
      .addCase(fetchFaqs.pending, function (state) {
        state.loading = true;
        state.error = "";
      })
      .addCase(fetchFaqs.fulfilled, function (state, action) {
        state.loading = false;
        state.list = action.payload.list;
        state.pagination = action.payload.pagination;
      })
      .addCase(fetchFaqs.rejected, function (state, action) {
        state.loading = false;
        state.error = action.payload || "Unable to retrieve FAQs";
      });
  },
});

export default faqSlice.reducer;